module.exports = __webpack_public_path__ + "static/titan-in-the-outfield-3b4d4ebe40e4c85d9b6e8f9b0b60e9c0.jpg";